export const isEmptyObject = (object: object) => {
  return Object.keys(object).length === 0
}
